import { render } from "./ChatGPT.vue?vue&type=template&id=6487a267&scoped=true"
import script from "./ChatGPT.vue?vue&type=script&lang=js"
export * from "./ChatGPT.vue?vue&type=script&lang=js"

import "./ChatGPT.vue?vue&type=style&index=0&id=6487a267&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6487a267"]])

export default __exports__